import { AuthorGroupPrivate, AuthorGroupsOrderBy, AuthorgroupsService } from "../client"

/* Interfaces */
export interface AddAuthorGroupProps {
    onClose: () => void
    isOpen: boolean
}

export interface DetailAuthorGroupProps {
    onClose: () => void
    isOpen: boolean
    authorgroup: AuthorGroupPrivate | null
}

export interface EditAuthorGroupProps {
    onClose: () => void
    isOpen: boolean
    authorgroup: AuthorGroupPrivate
}


/* Endpoints */
export const readAuthorgroups = ({
    per_page,
    page,
    order_by,
    descending,
    query,
}: {
    per_page: number,
    page: number
    order_by?: AuthorGroupsOrderBy
    descending?: boolean
    query?: string
}) => {
    return {
        queryFn: async () => {
        const data = await AuthorgroupsService.readAuthorgroups({
            skip: (page - 1) * per_page,
            limit: per_page,
            orderBy: order_by,
            descending: descending,
            query: query,
        })

        return data ?? { data: null, count: 0 }
        },
        queryKey: ["authorgroups", { page, order_by, descending, query }],
    }
}

export const readAuthorgroupsList = () => {
  return {
    queryFn: async () => {
      const data =  await AuthorgroupsService.readAuthorgroups({showInactive: false})
      return data ?? { data: null, count: 0 }
    },
    queryKey: ["authorgroups"],
  }
}
